import { render, staticRenderFns } from "./SellerProjects.vue?vue&type=template&id=f5297d42&scoped=true"
import script from "./SellerProjects.vue?vue&type=script&lang=js"
export * from "./SellerProjects.vue?vue&type=script&lang=js"
import style0 from "./SellerProjects.vue?vue&type=style&index=0&id=f5297d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5297d42",
  null
  
)

export default component.exports